import React, {Component} from 'react';
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { toggleLoadingHandler } from "../../../actions";
import View from "./loading";

class Loading extends Component {
    constructor(props) {
        super(props);
    }

    render(){
        const {
            toggleLoading,
            toggleLoadingHandler
        } = this.props;
        return (
            <View toggleLoading = {toggleLoading}
                  toggleLoadingHandler = {toggleLoadingHandler}/>
        )
    }
}

function mapStateToProps(state){
    return{
        toggleLoading: state.feedback.toggleLoading
    }
}

export default withRouter(connect(mapStateToProps, {
    toggleLoadingHandler
})(Loading));

